import React, { useState, useEffect } from 'react';
import { Route, Routes } from 'react-router-dom';
import DashboardLayout from './DashboardLayout';
import OverviewPage from '../features/overview/OverviewPage';
import HelpPage from '../features/help/HelpPage';
import ProfilePage from '../features/profile/ProfilePage';
import SettingsPage from '../features/settings/SettingsPage';
import SiteOverviewPage from '../features/site-overview/SiteOverviewPage';
import { useSites } from '../contexts/SitesContext';
import { useNavigate } from 'react-router-dom';
import { useDropdown } from '../contexts/DropdownContext';
import { useMobile } from '../contexts/MobileContext';

const Dashboard = () => {
  const navigate = useNavigate();
  const { isMobile } = useMobile();
  const [position, setPosition] = React.useState(0);
  const { fetchSites } = useSites();
  const [loading, setLoading] = useState(true);
  const { setSelectedOption, getSelectedOption } = useDropdown();
  const selectedPeriod = getSelectedOption('period');

  useEffect(() => {
    setSelectedOption('period', 'Last 30 days');
  }, [setSelectedOption]);

  useEffect(() => {
    if (selectedPeriod === null) return;

    setLoading(true);

    fetch(process.env.REACT_APP_SERVER_URL + '/api/validate-token', {
      method: 'POST',
      headers: {
        'Authorization': localStorage.getItem('token')
      },
    })
      .then(response => response.json())
      .then(data => {
        if (data.success) {
          fetchSites(selectedPeriod).then(() => {
            console.log('fetched!');
            setLoading(false);
          });
        }
        else if (data.message === 'invalid token!') {
          console.log('unauthorized access')
          localStorage.removeItem('token');
          navigate('/');
        }
      })
      .catch(error => {
        console.log('Automatic login failed');
        localStorage.removeItem('token');
        navigate('/');
      });
  }, [fetchSites, navigate, selectedPeriod]);

  return (
    <div className="dashboard"
         style={isMobile ? {overflow: 'hidden'} : {}}>
      <Routes>
        <Route element={<DashboardLayout bootLoading={loading} />}>
          <Route path="/" element={<OverviewPage position={position} setPosition={setPosition}/>} />
          <Route path="/help" element={<HelpPage />} />
          <Route path="/profile" element={<ProfilePage />} />
          <Route path="/settings" element={<SettingsPage />} />
          <Route path="/site/:website" element={<SiteOverviewPage />} />
        </Route>
      </Routes>
    </div>
  );
};

export default Dashboard;
